module.exports = __webpack_public_path__ + "46e09e0395c5c19e7b3e1f94129240a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/feedback-1.png
// module id = 1721
// module chunks = 0